<template>
  <div class="conditions">
    <div class="card-conditions">
      <button @click="toggleModal()" class="button is-small is-outlined">
        <span class="icon is-small">
          <i class="fas fa-plus"></i>
        </span>
        <span>Condition</span>
      </button>
      <div class="field is-grouped is-grouped-multiline has-text-grey">
        <div v-for="condition in activeConditions" :key="condition.idx" class="control">
          <div class="tags has-addons">
            <span class="tag">{{ condition.name }}</span>
            <a class="tag is-delete" @click="removeCondition(condition.id)"></a>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" :class="{ 'is-active': conditionsOpen }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Add a Condition</p>
          <button class="delete" aria-label="back" @click.prevent="toggleModal()"></button>
        </header>
        <section class="modal-card-body">
          <div class="conditions-list">
            <div class="field is-grouped">
              <p v-for="(condition, index) in conditions" :key="index" class="control">
                <button class="button is-medium is-rounded" @click="addCondition(condition.name)">{{ condition.name }}</button>
              </p>
            </div>
          </div>
          <hr>
          <div class="custom-condition">
            <form @submit.prevent="addCustomCondition()">
              <div class="field has-addons">
                <p class="control is-expanded has-icons-left">
                  <input 
                  v-model="customConditionName" 
                  placeholder="Condition Name" 
                  class="input is-rounded is-medium" 
                  required>
                  <span class="icon is-left">
                    <i class="fas fa-exclamation-circle"></i>
                  </span>
                </p>
                <p class="control">
                  <button type="submit" class="button is-rounded is-info is-medium">Add</button>
                </p>
              </div>
            </form>
          </div>
        </section>
        <footer class="modal-card-foot"></footer>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { db } from '../main'
// import Tooltip from '../components/Tooltip.vue'

export default {
  name: 'Conditions',
  props: {
    campaignId: String,
    collection: String,
    id: String
  },
  data () {
    return {
      conditionsOpen: false,
      entity: null,
      activeConditions: null,
      customConditionName: null
    }
  },
  firestore () {
    this.$bind('entity', db.collection('campaigns').doc(this.campaignId).collection(this.collection).doc(this.id))
    this.$bind('activeConditions', db.collection('campaigns').doc(this.campaignId).collection(this.collection).doc(this.id).collection('conditions'))
  },
  computed: {
    ...mapState({
      conditions: state => state.conditions
    }),
  },
  methods: {
    toggleModal () {
      this.conditionsOpen = (this.conditionsOpen) ? false : true
    },
    addCondition (conditionName) {
      db.collection('campaigns')
        .doc(this.campaignId)
        .collection(this.collection)
        .doc(this.id)
        .collection('conditions')
        .add({
          name: conditionName
        })
        .then(() => {
          console.log('condition added!')
          this.toggleModal()
          this.customConditionName = null
        })
    },
    removeCondition (id) {
      db.collection('campaigns')
        .doc(this.campaignId)
        .collection(this.collection)
        .doc(this.id)
        .collection('conditions')
        .doc(id)
        .delete()
        .then(() => {
          console.log('condition removed!')
        })
    },
    addCustomCondition () {
      const name = this.titleCase(this.customConditionName)
      this.addCondition(name)
    },
  },
  components: {
    // Tooltip,
  }
}
</script>
<style scoped>
/* .card-conditions {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
} */
.conditions {
  padding-left: inherit;
  padding-right: inherit;
}
.card-conditions {
  /* margin-right: 0.5em; */
  padding: inherit;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  transform: translateY(50%);
}
input {
  color: #4a4a4a;
}
.card-conditions > .button {
  /* padding-top: calc(0.25em - 1px);
  padding-bottom: calc(0.25em - 1px); */
  height: 2em;
}
.card-conditions {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-left: auto;
}
/* .card-conditions .control {
  margin-bottom: 0;
} */
.card-conditions .tags {
  box-shadow: 0 0 2px rgba(0,0,0,0.2);
  border-radius: 4px;
}
.card-conditions .tags .tag {
  margin-bottom: 0;
}
.card-conditions .tags .tag:not(.is-delete) {
  background-color: var(--brand-yellow);
}
.card-conditions .tags:not(:last-child) {
  margin: 0
}
/* .card-conditions .tag.is-danger {
  background-color: #C06;
} */
.conditions-list > .is-grouped {
  flex-wrap: wrap;
}
.conditions-list > .field.is-grouped > .control,
.conditions-list > .field.is-grouped > .control:not(:last-child) {
  margin: 0.5em;
}
</style>


// WEBPACK FOOTER //
// src/components/Conditions.vue